"use client";

import React from "react";

interface SavePercentageProps {
  originalPrice: number;
  discountedPrice: number;
  className?: string;
  template?: string;
}

const SavePercentage: React.FC<SavePercentageProps> = ({
  originalPrice,
  discountedPrice,
  className = "",
  template = "Save {value}%",
}) => {
  if (!originalPrice || originalPrice <= discountedPrice) return null;

  const discount = Math.round(
    ((originalPrice - discountedPrice) / originalPrice) * 100
  );

  const displayText = template.replace("{value}", discount.toString());

  return (
    <span className={`text-green-600 text-sm font-medium ${className}`}>
      {displayText}
    </span>
  );
};

export default SavePercentage;
